
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from '@shared-lib/services/loader.service';
import { SKIP_LOADER } from '@shared-lib/services/share-lib.service';
import { environment } from '../../../environments/environment';
import { DmttReturnTokenValidatorService } from '../services/dmtt-return-token-validator.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private tokenValidator: DmttReturnTokenValidatorService,
    private loader: LoaderService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipLoader = req.context.get(SKIP_LOADER) || this.loader.isSkipAutoSave?.();
    if (!skipLoader) {
      this.loader.show();
    }

    const token = this.tokenValidator.getSessionPayload()?.token || '';
    const authReq = token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    return next.handle(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          // Don't redirect to /login in development, and don't redirect for the
          // session-check endpoint (it's expected to 401 when not logged in).
          const isSessionCheck = req.url.includes('/api/v1/dmtt/session');
          if (!isSessionCheck) {
            this.tokenValidator.clearSession();
          }
          if (environment.production && !isSessionCheck) {
            this.router.navigate(['/login']);
          }
        }
        return throwError(() => err);
      }),
      finalize(() => { if (!skipLoader) { this.loader.hide(); } }),
    );
  }
}
